module.exports = __webpack_public_path__ + "img/s2P38.4b6b5e0b.png";